module.exports = __webpack_public_path__ + "public/files/img/signature.41538031.gif";